import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "h-full w-full" }
const _hoisted_2 = { class: "__setup-target-smart __section shadow-sm bg-white overflow-hidden" }
const _hoisted_3 = { class: "__section__header font-semibold text-neutral-600 p-6 border-b" }
const _hoisted_4 = { class: "font-normal leading-5 text-sm mt-2 text-neutral-500" }
const _hoisted_5 = { class: "grid grid-cols-2 border-t border-b border-neutral-200" }
const _hoisted_6 = {
  key: 1,
  fill: "none",
  height: "40",
  viewBox: "0 0 40 40",
  width: "40",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("rect", {
  fill: "#E5A42B",
  height: "40",
  rx: "20",
  width: "40"
}, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("path", {
  "clip-rule": "evenodd",
  d: "M26.7071 15.2929C27.0976 15.6834 27.0976 16.3166 26.7071 16.7071L18.7071 24.7071C18.3166 25.0976 17.6834 25.0976 17.2929 24.7071L13.2929 20.7071C12.9024 20.3166 12.9024 19.6834 13.2929 19.2929C13.6834 18.9024 14.3166 18.9024 14.7071 19.2929L18 22.5858L25.2929 15.2929C25.6834 14.9024 26.3166 14.9024 26.7071 15.2929Z",
  fill: "white",
  "fill-rule": "evenodd"
}, null, -1)
const _hoisted_9 = [
  _hoisted_7,
  _hoisted_8
]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", null, "Thiết lập Thời khoá biểu", -1)
const _hoisted_11 = /*#__PURE__*/_createStaticVNode("<div class=\"absolute h-full bg-neutral-300 left-0\" style=\"width:1px;\"></div><div class=\"absolute left-0 top-1/2 transform -translate-y-1/2 bg-white h-fit\"><svg fill=\"none\" height=\"72\" viewBox=\"0 0 12 72\" width=\"12\" xmlns=\"http://www.w3.org/2000/svg\"><mask id=\"path-1-outside-1_29551_14942\" fill=\"black\" height=\"72\" maskUnits=\"userSpaceOnUse\" width=\"13\" x=\"-1\" y=\"0\"><rect fill=\"white\" height=\"72\" width=\"13\" x=\"-1\"></rect><path d=\"M0 0V27.2195L10 36L0 44.7805V72\"></path></mask><path d=\"M0 27.2195H-1V27.6722L-0.659801 27.971L0 27.2195ZM10 36L10.6598 36.7514L11.5156 36L10.6598 35.2486L10 36ZM0 44.7805L-0.659801 44.029L-1 44.3278V44.7805H0ZM-1 0V27.2195H1V0H-1ZM-0.659801 27.971L9.3402 36.7514L10.6598 35.2486L0.659801 26.4681L-0.659801 27.971ZM9.3402 35.2486L-0.659801 44.029L0.659801 45.5319L10.6598 36.7514L9.3402 35.2486ZM-1 44.7805V72H1V44.7805H-1Z\" fill=\"#CBD5E1\" mask=\"url(#path-1-outside-1_29551_14942)\"></path></svg></div>", 2)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", null, "Bật tính năng Lịch học", -1)
const _hoisted_14 = { class: "__section__header font-semibold text-neutral-600 p-6 border-b" }
const _hoisted_15 = { class: "font-normal leading-5 text-sm mt-2 text-neutral-500" }
const _hoisted_16 = {
  key: 0,
  class: "__section__content"
}
const _hoisted_17 = { class: "form-group" }
const _hoisted_18 = { class: "input-group flex-nowrap flex items-center justify-between p-6 bg-neutral-50" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "w-56 uppercase text-neutral-400 text-xs font-semibold" }, " trạng thái ", -1)
const _hoisted_20 = { key: 0 }
const _hoisted_21 = {
  key: 1,
  class: "text-neutral-400"
}
const _hoisted_22 = { class: "font-semibold text-neutral-700" }
const _hoisted_23 = {
  key: 0,
  class: "mt-1"
}
const _hoisted_24 = { class: "font-semibold text-neutral-700" }
const _hoisted_25 = {
  key: 1,
  class: "mt-1"
}
const _hoisted_26 = { class: "uppercase text-blue-600 font-semibold text-sm mt-2" }
const _hoisted_27 = {
  key: 0,
  class: "p-6 flex items-center justify-end"
}
const _hoisted_28 = {
  key: 1,
  class: "__section__content"
}
const _hoisted_29 = { class: "form-group" }
const _hoisted_30 = { class: "input-group flex-nowrap flex items-center justify-between p-6 bg-neutral-50" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", { class: "input-group__label w-56 uppercase text-neutral-400 text-xs font-semibold" }, " Lịch học ", -1)
const _hoisted_32 = { class: "__setup-target-smart __section shadow-sm bg-white overflow-hidden mt-10" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", { class: "__section__header font-semibold text-neutral-600 p-6 border-b" }, [
  /*#__PURE__*/_createTextVNode(" Lịch học bán trú "),
  /*#__PURE__*/_createElementVNode("div", { class: "font-normal leading-5 text-sm mt-2 text-neutral-500" }, " Bật để kích hoạt tính năng Lịch học dành cho lớp bán trú. ")
], -1)
const _hoisted_34 = { class: "__section__content" }
const _hoisted_35 = { class: "form-group" }
const _hoisted_36 = { class: "input-group flex-nowrap flex items-center justify-between p-6 bg-neutral-50" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("div", { class: "input-group__label w-56 uppercase text-neutral-400 text-xs font-semibold" }, " LỊCH HỌC BÁN TRÚ ", -1)
const _hoisted_38 = { class: "__setup-target-smart __section shadow-sm bg-white overflow-hidden mt-10" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("div", { class: "__section__header font-semibold text-neutral-600 p-6 border-b" }, [
  /*#__PURE__*/_createTextVNode(" Nhận báo cáo theo lịch học "),
  /*#__PURE__*/_createElementVNode("div", { class: "font-normal leading-5 text-sm mt-2 text-neutral-500" }, [
    /*#__PURE__*/_createTextVNode(" Bật để kích hoạt chế độ tạo báo cáo theo thời khoá biểu. "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("Tắt để trở về chế độ tạo báo cáo mặc định: Một báo cáo mỗi ngày. Lịch học vẫn được hiển thị theo thời khoá biểu. ")
  ])
], -1)
const _hoisted_40 = { class: "__section__content" }
const _hoisted_41 = { class: "form-group" }
const _hoisted_42 = { class: "input-group flex-nowrap flex items-center justify-between p-6 bg-neutral-50" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("div", { class: "input-group__label w-56 uppercase text-neutral-400 text-xs font-semibold" }, " NHẬN BÁO CÁO THEO LỊCH HỌC ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PopupConfirm = _resolveComponent("PopupConfirm")!
  const _component_DaModalFrame = _resolveComponent("DaModalFrame")!
  const _component_SwitchButton = _resolveComponent("SwitchButton")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_DaModalFrame, {
      open: _ctx.modalIsOpen,
      "onUpdate:open": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.modalIsOpen) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_PopupConfirm, {
          type: _ctx.key,
          "onUpdate:type": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.key) = $event)),
          "is-off": _ctx.isOff,
          onClose: _ctx.cancel,
          onSubmit: _ctx.onSubmit
        }, null, 8, ["type", "is-off", "onClose", "onSubmit"])
      ]),
      _: 1
    }, 8, ["open"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createTextVNode(" Lịch học can thiệp cá nhân "),
          _createElementVNode("div", _hoisted_4, " Bật để quản lý lịch học và dạy theo thời khóa biểu, cùng với các chức năng quản lý chuyên cần như báo nghỉ, đổi " + _toDisplayString(_ctx.$filters.terminology('teacher')) + ", tạo buổi học phát sinh, v.v. Các báo cáo cũng sẽ được tạo tự động theo Thời khóa biểu. Thiết lập Thời khóa biểu là thao tác bắt buộc để kích hoạt các chức năng của Lịch học. ", 1)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", {
            class: _normalizeClass([
						_ctx.step === 1
							? 'border-yellow-500 text-yellow-600'
							: 'border-transparent text-neutral-400'
					, "font-semibold flex items-center gap-4 px-8 py-6 cursor-pointer border-b-2"]),
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.changeStep(1)))
          }, [
            (!_ctx.timetable)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: _normalizeClass([
							_ctx.step === 1
								? 'border-yellow-600'
								: 'border-neutral-200'
						, "h-10 w-10 rounded-full border-2 border-yellow-600 flex items-center justify-center"])
                }, " 01 ", 2))
              : (_openBlock(), _createElementBlock("svg", _hoisted_6, _hoisted_9)),
            _hoisted_10
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass([[
						_ctx.step === 2
							? 'border-yellow-500 text-yellow-600'
							: 'border-transparent text-neutral-500',
						!_ctx.timetable
							? 'cursor-not-allowed opacity-50'
							: 'cursor-pointer',
					], "border-b-2 font-semibold flex items-center gap-4 px-8 py-6 relative cursor-pointer"]),
            onClick: _cache[3] || (_cache[3] = 
						() => {
							if (_ctx.timetable) _ctx.changeStep(2);
						}
					)
          }, [
            _hoisted_11,
            _createElementVNode("div", {
              class: _normalizeClass([
							_ctx.step === 2
								? 'border-yellow-600'
								: 'border-neutral-200'
						, "h-10 w-10 rounded-full border-2 flex items-center justify-center"])
            }, " 02 ", 2),
            _hoisted_13
          ], 2)
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createTextVNode(_toDisplayString(_ctx.step === 1
						? 'Thiết lập Thời khoá biểu'
						: 'Lịch học can thiệp cá nhân') + " ", 1),
          _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.step === 1
							? 'Chỉ có thể bật tính năng lịch học nếu trung tâm đã thiết lập Thời khoá biểu'
							: 'Bật nếu muốn sử dụng các chức năng Lịch học dành cho buổi học can thiệp cá nhân.'), 1)
        ]),
        (_ctx.step === 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _hoisted_19,
                  (!_ctx.timetable)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_20, "Chưa thiết lập"))
                    : (_openBlock(), _createElementBlock("div", _hoisted_21, [
                        _createElementVNode("div", null, [
                          _createTextVNode(" Học sinh có TKB: "),
                          _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.timetable?.student_timetable_count ?? 0) + "/" + _toDisplayString(_ctx.student_count ?? 0), 1)
                        ]),
                        (_ctx.timetable?.activated_date)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                              _createTextVNode(" Thiết lập lúc: "),
                              _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.$filters.formatDateTime(
										_ctx.timetable?.inserted_at
									)), 1)
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.timetable?.created_by_staff)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                              _createTextVNode(" Thiết lập bởi: "),
                              _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.timetable?.created_by_staff?.name), 1)
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                ])
              ]),
              (!_ctx.timetable)
                ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                    _createElementVNode("button", {
                      class: "button-p btn--ghost text-center whitespace-nowrap w-fit px-6",
                      type: "button",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (
							_ctx.$router.push({
								path: '/schedule/timetable',
								query: { hasModal: 'true' },
							})
						))
                    }, " Thiết lập Thời khoá biểu ")
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        (_ctx.step === 2)
          ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
              _createElementVNode("div", _hoisted_29, [
                _createElementVNode("div", _hoisted_30, [
                  _hoisted_31,
                  _createElementVNode("div", {
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.openConfirm('enable_personal_schedule')))
                  }, [
                    _createVNode(_component_SwitchButton, { value: _ctx.enable_personal_schedule }, null, 8, ["value"])
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_32, [
        _hoisted_33,
        _createElementVNode("div", _hoisted_34, [
          _createElementVNode("div", _hoisted_35, [
            _createElementVNode("div", _hoisted_36, [
              _hoisted_37,
              _createElementVNode("div", {
                onClick: _cache[6] || (_cache[6] = ($event: any) => (
								_ctx.openConfirm('enable_day_care_class_schedule')
							))
              }, [
                _createVNode(_component_SwitchButton, { value: _ctx.enable_day_care_class_schedule }, null, 8, ["value"])
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_38, [
        _hoisted_39,
        _createElementVNode("div", _hoisted_40, [
          _createElementVNode("div", _hoisted_41, [
            _createElementVNode("div", _hoisted_42, [
              _hoisted_43,
              _createElementVNode("div", {
                onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.openConfirm('enable_report_by_session')))
              }, [
                _createVNode(_component_SwitchButton, { value: _ctx.enable_report_by_session }, null, 8, ["value"])
              ])
            ])
          ])
        ])
      ])
    ])
  ], 64))
}